const GradientButton = ({
  children,
  width = '300px',
  height = '60px',
  className = '',
  onClick,
  disabled = false,
  variant = 'primary',
  ...props
}) => {
  const getGradientColors = () => {
    switch (variant) {
      case 'primary':
        return 'bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800';
      case 'secondary':
        return 'bg-gradient-to-r from-orange-500 via-orange-600 to-orange-700';
      case 'outline':
        return 'bg-gradient-to-r from-gray-200 via-gray-300 to-gray-400';
      default:
        return 'bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800';
    }
  };

  const getTextColor = () => {
    switch (variant) {
      case 'outline':
        return 'text-gray-800';
      default:
        return 'text-white';
    }
  };

  const commonGradientStyles = `
    relative rounded-full cursor-pointer
    flex items-center justify-center
    transition-all duration-300 hover:scale-105 active:scale-95
    hover:shadow-lg active:shadow-md
    text-center
    ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
    ${getGradientColors()}
  `;

  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.();
    }
  };

  return (
    <div className="text-center">
      <div
        role="button"
        tabIndex={disabled ? -1 : 0}
        className={`${commonGradientStyles} ${className}`}
        style={{
          minWidth: width,
          height: height,
        }}
        onClick={disabled ? undefined : onClick}
        onKeyDown={handleKeyDown}
        aria-disabled={disabled}
        {...props}
      >
        <span className={`flex items-center justify-center font-medium text-sm ${getTextColor()}`}>
          {children}
        </span>
      </div>
    </div>
  );
};

export default GradientButton;